import { render, staticRenderFns } from "./ChartReview.vue?vue&type=template&id=3a661038&"
import script from "./ChartReview.vue?vue&type=script&lang=js&"
export * from "./ChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports